export default __webpack_public_path__ + "static/media/IMG_3.bfe8ce08.JPG";